import Header from './components/Header';
import Hero from './components/Hero';
import FaqSection from './components/FaqSection';
import TopicsSection from './components/TopicsSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import FeaturesSection from './components/FeaturesSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FaqSection />
        <TopicsSection />
        <UpdatesSection />
        <AboutSection />
        <CommentsSection />
        <IndexSection />
        <ContactSection />
        <MediaSection />
        <CarouselSection />
        <FeaturesSection />
        <AppSection />
        <CardsSection />
        <RankingSection />
      </main>
      <Footer />
    </>
  );
}